import {
	BulkUploadProcessModal,
	Button,
	DataTable,
	ErrorBoundary,
	Icons,
	RemoveRowLink,
	Card,
	Form,
	Input,
	Radio,
	BulkUploadUsersProcessModal,
} from '@components'
import { useCallback, useHistory, useRef, useRequest, useTranslation } from '@hooks'
import { api, message } from '@services'
import {
	TBulkUpload,
	TBulkUploadValidation,
	TFilteredRequest,
	TPost,
	TResponseWithFilters,
	TWardrobeItem,
	TSpreadSheetForUsersBulkUpload,
} from '@typings'
import * as React from 'react'
import { columns, formFieldRules } from './BulkUpload.tableOptions'
import { showFormErrors } from '@helpers'
const layout = {
	labelCol: { span: 4 },
	wrapperCol: { span: 14 },
}
import styles from './BulkUploadShops.module.css'

const BulkUploadShopsScreen: React.FC<TProps> = () => {
	const { t } = useTranslation()
	const tableRef = React.useRef<any>()
	const history = useHistory()
	const [form] = Form.useForm()

	// API data.
	const { data: { data: bulkList, meta } = {}, fetch, fetching } = useRequest<
		TResponseWithFilters<TPost[]>,
		TFilteredRequest & Partial<TWardrobeItem>
	>({
		request: (params) => api.getShopsBulkUploads({ ...params, order: ['id', 'desc'] }),
		onError: (error) => message.error(error.message),
	})

	// Bulk upload process.
	const processModal = React.useRef<any>()
	const { fetch: runShopBulkUpload, data: bulkUploadValidation, fetching: bulkUploading } = useRequest<
		TBulkUploadValidation,
		TBulkUpload
	>({
		request: (bulkUpload) => api.runShopBulkUpload(bulkUpload),
		onRequest: () => processModal.current?.open(),
		onSuccess: (validationResult) => {
			// if (!validationResult.errors) tableRef.current?.refresh()
		},
		onError: (error) => message.error(error.message),
	})
	console.log(bulkUploadValidation, 'bulkUploadValidationbulkUploadValidationbulkUploadValidation')

	return (
		<ErrorBoundary>
			<DataTable<TPost, Partial<TPost>>
				ref={tableRef}
				loading={fetching}
				columns={columns}
				dataSource={bulkList}
				meta={meta}
				onChange={fetch}
				renderActionsComponentWidth={350}
				renderActionsComponent={(item: TBulkUpload) => {
					return [
						<Form
							layout="inline"
							onFinish={(form) => runShopBulkUpload({ id: item.id, ...form })}
							initialValues={{ role: 'user' }}
						>
							<Form.Item name="role">
								<Radio.Group disabled={item.isUploaded}>
									<Radio value={'user'}>{t('Active')}</Radio>
								</Radio.Group>
							</Form.Item>
							<Button
								key="1"
								type="link"
								htmlType="submit"
								disabled={item.isUploaded}
								//onClick={() => runUserBulkUpload(item)}
							>
								{t('Upload')}
							</Button>
							<RemoveRowLink
								key="2"
								id={item.id}
								request={api.removeShopBulkUpload}
								onSuccess={tableRef.current?.refresh}
							/>
						</Form>,
					]
				}}
			/>
			<BulkUploadUsersProcessModal
				ref={processModal}
				bulkUploadValidation={bulkUploadValidation}
				loading={bulkUploading}
				description={t('Trying to create users')}
				type="users"
			/>
		</ErrorBoundary>
	)
}

type TProps = {
	/** */
}

export default BulkUploadShopsScreen
